module.exports = __webpack_public_path__ + "img/icon-facebook.1a8d597c.svg";